<template src="./template.html"></template>
<script>
import { mapState } from 'vuex'

import urlUtils from 'utils/urlUtils'

export default {
  name: 'powered-by',
  props: {
    theme: {
      type: String,
      default: 'theme-light',
    },
    path: {
      type: String,
      default: '',
    },
  },
  computed: {
    ...mapState({
      venue: (state) => state.venue.current,
    }),
    url() {
      // https://www.tablelistpro.com/?utm_source=foobar&utm_medium=link&utm_campaign=widget-

      const widgetName = (window.location.pathname || '').replace(/\/widgets\//gi, '')

      const params = {
        utm_source: window.location.href,
        utm_medium: 'link',
        utm_campaign: `widget-${widgetName}`,
      }

      const fullUrl = urlUtils.combinePaths('http://www.tablelistpro.com', this.path)

      return urlUtils.addQueryStringParams(fullUrl, params)
    },
  },
  data() {
    return {}
  },
}
</script>



// WEBPACK FOOTER //
// src/components/PoweredBy/index.vue